import axios, { AxiosInstance } from 'axios';
import { getApiHost } from '../config';
import { getAuthTokenFromStorage } from '../utils';
import { SearchResult } from './entities/search-result';
import { apiErrorHandler } from '../api/error-handler-old';

interface FindParams {
	readonly text: string;
	readonly expand?: string[];
	readonly abortSignal: AbortSignal;
}

export class SearchService {
	constructor() {
		this.axiosClient = axios.create({
			baseURL: getApiHost()
		});

		this.axiosClient.interceptors.response.use(undefined, apiErrorHandler);
	}

	private axiosClient: AxiosInstance;

	private get token(): string {
		return getAuthTokenFromStorage();
	}

	public async find({
		text,
		expand = [],
		abortSignal
	}: FindParams) : Promise<SearchResult> {
		const response = await this.axiosClient.get<SearchResult>('search', {
			signal: abortSignal,

			headers: {
				Authorization: `Bearer ${this.token}`,
			},

			params: {
				search: text,
				$expand: expand,
			}
		});

		// @ts-ignore move it to new API logic
		return response.data;
	}
}
